import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const service = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜その他のサービス';
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "その他のサービス" }])}

      <div className="service">
        <h2 id="contentsHead">その他のサービス</h2>
        <p className="mt30 center">
          <img
            src="resource/img/static/service/tel.gif"
            width="578"
            height="124"
            alt="電話番号"
          />
        </p>

        <h3 className="mt30">
          <img
            src="resource/img/static/service/tl_benri.gif?20150515"
            width="870"
            height="36"
            alt="便利なサービス"
          />
        </h3>
        <p className="mt30 opacityImg btnArea" id="service_02">
          <a
            href="/carrieservice/"
            target="_blank"
          >
            <img
              src="resource/img/static/service/unpan2_0904.gif?20230410"
              width="870"
              height="204"
              alt="ハロー宅配便 詳しくはこちら（PDF）をご覧ください。"
            />
          </a>
        </p>
        <p className="mt30 opacityImg btnArea" id="service_04">
          <a href="/anshinpack/">
            <img
              src="resource/img/static/service/anshin2019.gif?20210910"
              width="870"
              height="204"
              alt="ハロー安心保証パック"
            />
          </a>
        </p>

        <h3 className="mt30">
          <img
            src="resource/img/static/service/tl_option.gif?20220419"
            width="870"
            height="36"
            alt="オプションサービス"
          />
        </h3>
        <p className="mt30 opacityImg btnArea" id="service_07">
          <a href="/concierge/">
            <img
              src="resource/img/static/service/concierge.gif?20220419"
              width="870"
              height="228"
              alt="お片付けコンシェルジュ"
            />
          </a>
        </p>

        <h3 className="mt30" id="service_05">
          <img
            src="resource/img/static/service/tl_buppan.gif?1533190593"
            width="870"
            height="36"
            alt="物品販売"
          />
        </h3>
        <p className="mt30 opacityImg btnArea" id="service_06">
          <img
            src="resource/img/static/service/led.gif?20200526"
            width="870"
            height="228"
            alt="LEDライト"
          />
        </p>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/service.jsx